import React from 'react';
import { Image as BuilderImage } from '@builder.io/react';

const Hero = ({ heroImage, heroTitle }) => (
  <div className="rs-breadcrumbs">
    {heroImage?.image && (
      <div className='hero-container'>
        <BuilderImage
          className='hero-image'
          image={heroImage.image}
          style={{ minWidth: 200, minHeight: 200 }}
          alt={heroImage.alt}
        />
      </div>
    )}
    <div
      className="container"
      style={{
        position: 'absolute',
        top: 0,
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end'
      }}
    >
      <div className="breadcrumbs-inner">
        <h1 className="page-title orange-style">
          {heroTitle}
          {/* <span className="watermark">{data.strapiCommconSpeakersPage.HeroTitle}</span> */}
        </h1>
      </div>
    </div>
  </div>
);

export default Hero;
